<template>
  <div>
    <div class="row">
      <div
        class="col-lg-4 order-lg-1 order-md-0 vld-parent d-flex align-items-stretch"
        ref="card_startup"
      >
        <startup-batch-info
          v-if="startup"
          :startup="startup"
          :batch="data"
          class="flex-grow-1"
        />
      </div>
      <div
        class="col-lg-8 mt-lg-0 mt-3 vld-parent d-flex align-items-stretch"
        ref="card_stats"
      >
        <card shadow type="secondary" class="flex-grow-1">
          <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
              <div class="col-8">
                <h3 class="mb-0">
                  Painel mensal da Startup -
                  <span class="text-warning">{{ startup.name || "..." }}</span>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-12">
            <open-tasks :batchId="data.id" />
            <hr class="my-4" />
            <startup-metrics :batchId="data.id" />
          </div>
        </card>
      </div>
    </div>
    <div class="row mt-3" v-if="cards.length">
      <div class="col-lg-12">
        <card shadow type="secondary">
          <div class="col-12">
            <CustomCardList :data="cards" />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import StartupBatchInfo from "./StartupDashboard/StartupBatchInfo";
import OpenTasks from "./StartupDashboard/OpenTasks";
import StartupMetrics from "./StartupDashboard/StartupMetrics";
import CustomCardList from "@/components/CustomCardList";
import api from "@/services/api.js";

export default {
  name: "startup-dashboard-stats",
  components: {
    OpenTasks,
    StartupMetrics,
    StartupBatchInfo,
    CustomCardList,
  },
  props: {
    data: {
      type: Object,
      description: "Batch data",
      required: true,
    },
  },
  data() {
    return {
      startup: "",
      cards: "",
    };
  },
  async mounted() {
    const loaderStartup = this.$loading.show({
      container: this.$refs.card_startup,
      width: 140,
      height: 140,
    });
    try {
      const { data } = await api.get("/startups");
      if (!data) throw new Error("Startup not found");
      this.startup = data;
      const defaultLogoPath = "/img/pages/default_logo.png";
      if (!this.startup.logo) this.startup.logo = { url: defaultLogoPath };
      loaderStartup.hide();
      await this.loadCards();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao carregar informações");
    }
  },
  methods: {
    async loadCards() {
      try {
        const { data: cards } = await api.get(
          `/startup-dashboard/${this.data.id}/cards`
        );
        if (cards.length) this.cards = cards;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao carregar os cards");
      }
    },
  },
};
</script>
